<template>
  <!-- qw-layout-main：business-page-theme.scss 的页面 flex 撑满布局挂载点 -->
  <section class="qw-app-main qw-layout-main">
    <transition name="fade-transform" mode="out-in">
      <router-view :key="key" />
    </transition>
  </section>
</template>

<script>
export default {
    name: 'AppMain',
    computed: {
        key () {
            return this.$route.path
        }
    }
}
</script>

<style lang="scss" scoped>
.qw-app-main {
    display: flex;
    flex-direction: column;
}

.fade-transform-leave-active,
.fade-transform-enter-active {
    transition: all 0.2s;
}

.fade-transform-enter {
    opacity: 0;
    transform: translateX(-10px);
}

.fade-transform-leave-to {
    opacity: 0;
    transform: translateX(10px);
}
</style>
